import { render } from "./chat_base.vue?vue&type=template&id=44f6baf0&scoped=true"
import script from "./chat_base.vue?vue&type=script&lang=js"
export * from "./chat_base.vue?vue&type=script&lang=js"

import "./chat_base.vue?vue&type=style&index=0&id=44f6baf0&scoped=true&lang=css"

import exportComponent from "/home/hkohashi/webinar-master-php83/frontend-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44f6baf0"]])

export default __exports__